import { useState, useEffect } from 'react'
import { CONCESSIONS, getDestinataires, ajouterDestinataire, modifierDestinataire, supprimerDestinataire } from '../lib/supabase'
import './Dashboard.css'
import './Admin.css'

export default function Admin() {
  const [testSent, setTestSent] = useState(false)
  const [testLoading, setTestLoading] = useState(false)
  const [destinataires, setDestinataires] = useState([])
  const [loadingDest, setLoadingDest] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [editId, setEditId] = useState(null)
  const [formNom, setFormNom] = useState('')
  const [formCourriel, setFormCourriel] = useState('')
  const [formRole, setFormRole] = useState('')
  const [formError, setFormError] = useState('')
  const [formLoading, setFormLoading] = useState(false)

  useEffect(() => {
    loadDestinataires()
  }, [])

  async function loadDestinataires() {
    setLoadingDest(true)
    try {
      const data = await getDestinataires()
      setDestinataires(data)
    } catch (e) {
      console.error(e)
    } finally {
      setLoadingDest(false)
    }
  }

  async function handleTestEmail() {
    setTestLoading(true)
    try {
      const response = await fetch('/api/send-report', { method: 'POST' })
      const data = await response.json()
      if (data.success) {
        setTestSent(true)
        setTimeout(() => setTestSent(false), 5000)
      } else {
        alert('Erreur : ' + data.error)
      }
    } catch (e) {
      alert('Erreur lors de l\'envoi : ' + e.message)
    } finally {
      setTestLoading(false)
    }
  }

  function ouvrirAjout() {
    setEditId(null)
    setFormNom('')
    setFormCourriel('')
    setFormRole('')
    setFormError('')
    setShowForm(true)
  }

  function ouvrirModif(d) {
    setEditId(d.id)
    setFormNom(d.nom)
    setFormCourriel(d.courriel)
    setFormRole(d.role || '')
    setFormError('')
    setShowForm(true)
  }

  async function handleSauvegarder() {
    if (!formNom.trim() || !formCourriel.trim()) {
      setFormError('Le nom et le courriel sont obligatoires.')
      return
    }
    setFormLoading(true)
    setFormError('')
    try {
      if (editId) {
        await modifierDestinataire(editId, { nom: formNom, courriel: formCourriel, role: formRole })
      } else {
        await ajouterDestinataire({ nom: formNom, courriel: formCourriel, role: formRole })
      }
      setShowForm(false)
      await loadDestinataires()
    } catch (e) {
      setFormError('Erreur : ' + e.message)
    } finally {
      setFormLoading(false)
    }
  }

  async function handleSupprimer(id, nom) {
    if (!window.confirm(`Supprimer ${nom} de la liste des destinataires ?`)) return
    try {
      await supprimerDestinataire(id)
      await loadDestinataires()
    } catch (e) {
      alert('Erreur lors de la suppression.')
    }
  }

  const prochainLundi = (() => {
    const d = new Date()
    const day = d.getDay()
    const diff = day === 0 ? 1 : 8 - day
    d.setDate(d.getDate() + diff)
    return d.toLocaleDateString('fr-CA', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
  })()

  return (
    <div className="admin-page">
      <div className="page-header">
        <div>
          <h1>Administration</h1>
          <p>Gestion des rapports hebdomadaires et paramètres du système</p>
        </div>
      </div>

      <div className="admin-grid">

        <div className="admin-section">
          <div className="section-title">Rapport hebdomadaire automatique</div>
          <div className="table-wrap">
            <table>
              <tbody>
                <tr><td className="param-label">Fréquence</td><td>Chaque lundi à 15h00</td></tr>
                <tr><td className="param-label">Prochain envoi</td><td>{prochainLundi}</td></tr>
                <tr><td className="param-label">Expéditeur</td><td>rapports@groupeleclair.com</td></tr>
                <tr><td className="param-label">Contenu</td><td>Sommaire semaine + tableau par concession + comparatif année précédente</td></tr>
                <tr><td className="param-label">Destinataires</td><td>{destinataires.length} personnes</td></tr>
              </tbody>
            </table>
          </div>
          <div className="admin-actions">
            <button className="submit-btn" onClick={handleTestEmail} disabled={testLoading}>
              {testLoading ? 'Envoi en cours…' : 'Envoyer un rapport test maintenant'}
            </button>
            {testSent && <div className="success-msg" style={{marginTop:'10px'}}>Rapport envoyé à tous les destinataires.</div>}
          </div>
        </div>

        <div className="admin-section">
          <div className="section-title" style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <span>Liste des destinataires</span>
            <button onClick={ouvrirAjout} style={{background:'#C8102E', color:'white', border:'none', borderRadius:'6px', padding:'5px 14px', fontSize:'12px', fontWeight:'500', cursor:'pointer'}}>
              + Ajouter
            </button>
          </div>

          {showForm && (
            <div className="dest-form">
              <div className="dest-form-grid">
                <div className="form-group">
                  <label>Nom</label>
                  <input type="text" value={formNom} onChange={e => setFormNom(e.target.value)} placeholder="Prénom Nom" />
                </div>
                <div className="form-group">
                  <label>Courriel</label>
                  <input type="email" value={formCourriel} onChange={e => setFormCourriel(e.target.value)} placeholder="exemple@groupeleclair.com" />
                </div>
                <div className="form-group">
                  <label>Rôle</label>
                  <input type="text" value={formRole} onChange={e => setFormRole(e.target.value)} placeholder="DG Chomedey Hyundai" />
                </div>
              </div>
              {formError && <div className="error-msg">{formError}</div>}
              <div style={{display:'flex', gap:'8px', marginTop:'12px'}}>
                <button className="submit-btn" style={{padding:'8px 20px'}} onClick={handleSauvegarder} disabled={formLoading}>
                  {formLoading ? 'Sauvegarde…' : editId ? 'Mettre à jour' : 'Ajouter'}
                </button>
                <button onClick={() => setShowForm(false)} style={{background:'none', border:'1px solid #ddd', borderRadius:'6px', padding:'8px 16px', fontSize:'13px', cursor:'pointer'}}>
                  Annuler
                </button>
              </div>
            </div>
          )}

          <div className="table-wrap" style={{marginTop:'12px'}}>
            <table>
              <thead>
                <tr><th>Nom</th><th>Courriel</th><th>Rôle</th><th></th></tr>
              </thead>
              <tbody>
                {loadingDest ? (
                  <tr><td colSpan={4} style={{textAlign:'center', color:'#888', padding:'20px'}}>Chargement…</td></tr>
                ) : destinataires.map(d => (
                  <tr key={d.id}>
                    <td className="conc-name">{d.nom}</td>
                    <td style={{fontSize:'12px', color:'#666'}}>{d.courriel}</td>
                    <td style={{fontSize:'12px', color:'#888'}}>{d.role}</td>
                    <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                      <button onClick={() => ouvrirModif(d)} style={{background:'none', border:'none', fontSize:'12px', color:'#185FA5', cursor:'pointer', marginRight:'8px'}}>
                        Modifier
                      </button>
                      <button onClick={() => handleSupprimer(d.id, d.nom)} style={{background:'none', border:'none', fontSize:'12px', color:'#C8102E', cursor:'pointer'}}>
                        Supprimer
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="admin-section">
          <div className="section-title">Statut des saisies — semaine courante</div>
          <SaisieStatus />
        </div>

      </div>
    </div>
  )
}

function SaisieStatus() {
  const today = new Date()
  const day = today.getDay()
  const diff = day === 0 ? -6 : 1 - day
  const lundi = new Date(today)
  lundi.setDate(today.getDate() + diff)

  const jours = []
  for (let i = 0; i < 6; i++) {
    const d = new Date(lundi)
    d.setDate(lundi.getDate() + i)
    if (d <= today) {
      jours.push(d.toISOString().split('T')[0])
    }
  }

  return (
    <div className="status-grid">
      {CONCESSIONS.map(c => (
        <div key={c.id} className="status-card">
          <div className="status-card-header">
            <span className="conc-name" style={{fontSize:'13px'}}>{c.label}</span>
            <span className={`brand-tag tag-${c.marque.toLowerCase()}`}>{c.marque}</span>
          </div>
          <div className="status-dots">
            {['L','M','M','J','V','S'].slice(0, jours.length).map((jour, i) => (
              <div key={i} className="status-dot-wrap">
                <div className="status-dot status-unknown" title={jours[i]} />
                <span>{jour}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
